import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/phone_bg.png';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	${Text} {
		color: #ffffff;
		font-weight: 500;
	}
`;

const StyledBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 380px;
	height: 590px;
	background-image: url(${bg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	pointer-events: none;
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 100px;
	margin-top: 225px;
`;

const StyledButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	border-radius: 60px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: opacity 0.3s ease;
		/* transform: rotate(135deg); */
	}
`;

export { StyledBg, StyledButton, StyledButtonsContainer, StyledContainer };
